<template>
  <div class="planned-activity-row">
    <p class="planned-activity-hour-title">
      <strong class="planned-activity-hour-chips">
        <b-icon icon="clock-time-four-outline" size="is-small" class="mr-1" />
        {{ start() }}
      </strong>
      <span
        v-if="(showRemainingPlace && this.plannedActivity.max !== null) || remainingPlaces() === 0"
        v-bind:class="remainingPlaces() === 0 ? 'text-danger' : ''"
      >
        {{ $tc('remainingPlaces', remainingPlaces(), { count: remainingPlaces() }) }}
      </span>
    </p>

    <!-- Product in planned activity -->
    <div
      v-for="(activityProduct, index) in plannedActivity.products"
      :key="`activity-product-${index}`"
    >
      <planned-activity-product-row
        :activity-product="activityProduct"
        :planned-activity="plannedActivity"
        :time-slot-format="timeSlotFormat"
        class="mb-5 pl-3"
        :slotable="slotable"
        :max-slotable-places="maxSlotablePlaces"
        :slotable-callback="slotableCallback"
        :get-daily-activity="getDailyActivity"
        :show-remaining-place="showRemainingPlace"
        :direct-to-card="directToCard"
      />
    </div>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { HelpersMixin } from "@/mixins/HelpersMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import VueI18n from "vue-i18n";
import moment from "@/services/momentjs";
import PlannedActivityProductRow from "@/components/partial/PlannedActivityProductRow";

export default {
  name: "PlannedActivityRow",
  components: { PlannedActivityProductRow },
  mixins: [LocaleMixin, HelpersMixin, ConfigMixin],
  props: {
    plannedActivity: Object,
    slotable: {
      type: Boolean,
      default: false
    },
    maxSlotablePlaces: {
      type: [Number, String],
      default: null
    },
    slotableCallback: Function,
    timeSlotFormat: {
      type: String,
      default: "HH[h]mm"
    },
    showRemainingPlace: {
      type: Boolean,
      default: true
    },
    getDailyActivity: {
      type: Function,
      default: null
    },
    directToCard: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      reservations: [],
      placeInReservation: 0
    };
  },

  methods: {
    start() {
      return moment(this.plannedActivity.start_at).format(this.timeSlotFormat);
    },

    remainingPlaces() {
      return this.plannedActivity.max - this.plannedActivity.participants_count - (this.plannedActivity.reservations_in_baskets || 0);
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        remainingPlaces: "No remaining places | One remaining place | {count} remaining places",
        addToCart: "Add to cart",
        places: "Places",
        error: "An error occurred while adding to the cart.",
        successToAdded: "%{count} product added to | {count} products added to",
        cart: "cart"
      },
      fr: {
        remainingPlaces: "Aucune places restantes | Une place restante | {count} places restantes",
        addToCart: "Ajouter au panier",
        places: "Places",
        error: "Une erreur s'est produite lors de l'ajout au panier.",
        successToAdded:
          "%{count} produit ajouté au | {count} produits ajoutés au",
        cart: "panier"
      }
    }
  })
};
</script>

<style lang="scss" src="../../assets/styles/buefy/base.scss"></style>
<style lang="scss">
.planned-activity-row {
  .planned-activity-hour-title {
    border-bottom-style: solid;
    border-width: 1px;
    border-color: rgb(220, 220, 220);
    margin-bottom: 5px;
    padding-bottom: 3px;
    .planned-activity-hour-chips {
      display: inline-block;
      border-radius: 5px;
      background-color: rgb(230, 230, 230);
      padding: 0 7px;
    }
  }
}
</style>
